<template>
  <div :style="daStyle">
    <!-- {{ percent.toFixed(1) }}<br /> -->
    <!-- {{ parseInt(angle) }}&deg;<br />-->
    <!-- {{ power.toFixed(1) }} -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import StyleUtilities from "@/assets/js/StyleUtilities";

export default {
  name: "HeatMapElement",
  mixins: [StyleUtilities],
  props: {
    size: {
      type: Number,
      default: 10,
    },
    // percent: null,
    // angle: null,
    // power: null,
    color: null,
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    daStyle: function () {
      let rtn = "";
      rtn += `width: ${this.size}px;`;
      rtn += `height: ${this.size}px;`;
      //   rtn += `border: 1px solid black;`;
      if (this.color) rtn += this.color;
      return rtn;
    },
    // scoreColor: function () {
    //   return this.percentageToHsl(this.percent, 0, 120);
    // },
    // dataEl: function () {
    //   let rtn = "";
    //   if (this.power) rtn += this.power.toFixed(1);
    //   if (this.percent) rtn += " " + parseInt(this.percent * 100);
    //   return rtn;
    // },
  },
};
</script>

<style scoped></style>
